// extracted by mini-css-extract-plugin
export default {"MainDiv":"AllOrder_MainDiv__xbmg3","TableDiv":"AllOrder_TableDiv__OPxsS","TableButton":"AllOrder_TableButton__M+bAV"};